import {Schema} from "common/flowmaster/types/schema";
import SchemaEditor from "common_components/flowmaster/editors/schema_editor";

const initialSchema: Schema = {
  name: "",
  description: "",
  parameters: {
    type: "object",
    properties: {},
    required: [],
  },
};

const ActionArg = {
  Component: SchemaEditor,
  default: {value: initialSchema},
};

export default ActionArg;
